import { Button, Result } from "antd";
import { useTranslation } from "react-i18next";

const ErrorGettingProduct = () => {
  const { t } = useTranslation();
  return (
    <>
      <div style={{ display: "flex", justifyContent: "center", paddingTop: 25 }}>
        <img className="img-fluid" src={"/img/logo-white.png"} alt="" />
      </div>
      <Result
        status="404"
        title="404"
        subTitle={t("errorGettingProduct.subTitle")}
        extra={
          <div>
            <Button
              type="link"
              onClick={() => {
                window.location.href = "https://salespark.io";
              }}
            >
              {t("errorGettingProduct.goToSiteButton")}
            </Button>
            <Button
              type="primary"
              onClick={() => {
                window.location.reload();
              }}
            >
              {t("errorGettingProduct.retryButton")}
            </Button>
          </div>
        }
      />
    </>
  );
};

export default ErrorGettingProduct;
